/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import algoliasearch from 'algoliasearch'
import CoachCard from '@components/coach-card'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import { useStyles } from './facility-page.styles'

const searchClient = algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_API_KEY)
const index = searchClient.initIndex(process.env.ALGOLIA_COACH_INDEX_NAME)

const getCoaches = async (id, setCoaches) => {
  const { hits } = await index.search('', {
    hitsPerPage: 100,
    facetFilters: [`facilities.externalFacilityId:${id}`],
  })
  setCoaches(hits)
}
const Coaches = ({ id }) => {
  const s = useStyles()
  const [coaches, setCoaches] = useState([])
  useEffect(() => {
    getCoaches(id, setCoaches)
  }, [])

  if (coaches.length === 0) return null

  return (
    <Box pt={[4, 4, 8]}>
      <Typography variant="h4" className={s.headlinePros}>PGA Coaches</Typography>
      <Grid container spacing={4}>
        {coaches.map((coach) => {
          return (
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <CoachCard coachInfo={{ ...coach }} source="facility page" className={s.coachCard} />
            </Grid>
          )
        })}
      </Grid>
    </Box>
  )
}

Coaches.propTypes = {
  id: PropTypes.string,
}

export default Coaches
